function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".mediaServer-icon{fill:url(#mediaServer);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "mediaServer",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "40%",
  stopColor: "#F66614"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7B00FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M42.12061,7.93384a2.00257,2.00257,0,0,0,.70471-.12848c.30109-.11334.60211-.22375.9071-.33221a2.00125,2.00125,0,1,0-1.343-3.77045q-.48972.17441-.97357.35663a2.00126,2.00126,0,0,0,.70477,3.87451Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M17.61865,24.74158a1.9942,1.9942,0,0,0,1.49457-.66925q.32108-.35907.649-.71472A2.0014,2.0014,0,0,0,16.822,20.64142q-.35184.381-.69592.76746a2.00075,2.00075,0,0,0,1.49255,3.3327Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M12.59845,95.17542a2.00192,2.00192,0,0,0-3.42108,2.08014q.26825.4411.54443.87738a2.0013,2.0013,0,1,0,3.38391-2.13776Q12.84918,95.58768,12.59845,95.17542Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M33.08887,12.1889a1.99291,1.99291,0,0,0,.99506-.26624q.42078-.24179.84454-.47583A2.00159,2.00159,0,0,0,32.98334,7.948c-.29816.16614-.59723.33417-.89343.5047a2.0009,2.0009,0,0,0,.999,3.73621Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M1.93048,60.873c.05573.00488.11139.00684.16614.00684a2.00176,2.00176,0,0,0,1.993-1.83685q.03964-.48441.087-.96631a2.00149,2.00149,0,0,0-3.98413-.38794q-.0499.51151-.0929,1.02594A2.00088,2.00088,0,0,0,1.93048,60.873Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M5.58521,78.26117q-.11435-.46683-.22-.9375a2.00182,2.00182,0,0,0-3.90588.87933q.11435.50638.23749,1.00977a2.00156,2.00156,0,0,0,3.88837-.9516Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M2.22369,70.86536A2.00172,2.00172,0,0,0,4.0672,68.71729c-.02441-.3219-.04791-.64435-.06744-.96777a2.00171,2.00171,0,0,0-3.99585.24622q.03223.51443.07135,1.0274a2.00153,2.00153,0,0,0,1.994,1.84808C2.12012,70.87122,2.17188,70.86926,2.22369,70.86536Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M8.25562,86.54462a2.002,2.002,0,0,0-3.71045,1.50464c.13.31854.261.636.39587.95166a2.00131,2.00131,0,0,0,3.683-1.5672Q8.4364,86.99115,8.25562,86.54462Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M3.23047,50.96179A1.99957,1.99957,0,0,0,5.6546,49.50012q.11581-.4682.24042-.93311A2.00212,2.00212,0,0,0,2.02625,47.5343q-.13339.50052-.25806,1.00439A2.00055,2.00055,0,0,0,3.23047,50.96179Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M6.11206,41.38324a2.001,2.001,0,0,0,2.62933-1.04932q.19208-.44632.391-.88867a2.00216,2.00216,0,0,0-3.65375-1.63849c-.14075.31464-.28052.63116-.41638.94824A2.00112,2.00112,0,0,0,6.11206,41.38324Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M24.85089,17.84216a1.99068,1.99068,0,0,0,1.25995-.447q.37527-.30487.75458-.60236a2.00118,2.00118,0,1,0-2.46906-3.15q-.40613.31805-.80737.64441a2.001,2.001,0,0,0,1.2619,3.555Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M121.00629,45.25677c.09973.30634.19843.61359.29321.92188a2.00216,2.00216,0,0,0,3.82581-1.18225q-.154-.49466-.31476-.98437a2.00136,2.00136,0,0,0-3.80426,1.24475Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M117.68878,37.21075a2.0017,2.0017,0,0,0,3.58337-1.7851q-.23016-.46307-.47015-.92035a2.00128,2.00128,0,0,0-3.55011,1.84857Q117.47327,36.7796,117.68878,37.21075Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M106.41382,21.58185a2.00158,2.00158,0,0,0,2.83466-2.82666q-.36511-.36566-.737-.72546a2.00111,2.00111,0,1,0-2.78577,2.87354Q106.07169,21.23962,106.41382,21.58185Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M123.27106,54.659q.0748.47552.14075.95306a2.00225,2.00225,0,0,0,3.96655-.55q-.07187-.51443-.15253-1.02545a2.00173,2.00173,0,0,0-3.95477.62244Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M51.73,5.1908a2.00322,2.00322,0,0,0,.39294-.03912c.31573-.063.63239-.12311.952-.1817a2.00086,2.00086,0,1,0-.71942-3.93652q-.50876.09229-1.01459.19342A2.00114,2.00114,0,0,0,51.73,5.1908Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M71.39642,4.44775q.48093.05933.96179.12653a2.00083,2.00083,0,1,0,.55524-3.963C72.57135.56348,72.23114.51849,71.889.476a2.00109,2.00109,0,1,0-.49261,3.97174Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M98.25891,14.74976q.39734.27777.79077.56134a2.00143,2.00143,0,0,0,2.34393-3.24481q-.41931-.30258-.84357-.59747a2.00087,2.00087,0,1,0-2.29114,3.28094Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M61.658,4.031c.02441,0,.04987-.00049.07428-.00146q.48239-.01758.9657-.02734a2.00094,2.00094,0,1,0-.08209-4.001q-.51608.01025-1.03021.0293A2.00092,2.00092,0,0,0,61.658,4.031Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M80.869,6.40723q.46335.1355.92273.27893a2.00132,2.00132,0,1,0,1.19446-3.82025q-.49411-.1539-.9931-.2995A2.001,2.001,0,1,0,80.869,6.40723Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M89.90265,9.87329q.43689.20883.869.42554a2.001,2.001,0,1,0,1.79456-3.577q-.46472-.233-.93347-.4577a2.00121,2.00121,0,1,0-1.73,3.60919Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M13.23376,28.19989a2.00231,2.00231,0,0,0-2.774.56378q-.28592.43231-.564.86761A2.00166,2.00166,0,0,0,13.27,31.78564q.261-.40814.52881-.81287A2,2,0,0,0,13.23376,28.19989Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M114.73688,99.72162a2.00291,2.00291,0,0,0-2.80432.39227c-.1955.25946-.39392.51739-.59235.77386a2.00121,2.00121,0,0,0,3.16309,2.45239q.31522-.40521.62555-.81586A2.0016,2.0016,0,0,0,114.73688,99.72162Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M105.50775,107.348q-.34753.33417-.70282.66241a2.00159,2.00159,0,0,0,2.72125,2.936c.25415-.23492.50433-.47186.7536-.71027a2.00161,2.00161,0,1,0-2.772-2.88818Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M98.0116,113.46143q-.39734.27411-.79858.54132a2.00147,2.00147,0,0,0,2.21881,3.33173q.43112-.28656.85529-.58038a2.00122,2.00122,0,1,0-2.27551-3.29266Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M115.32239,25.77289a2.00193,2.00193,0,0,0-3.208,2.39575q.28885.38544.5708.77673a2.00145,2.00145,0,0,0,3.24908-2.33807Q115.63223,26.18744,115.32239,25.77289Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M125.99817,62.0191a2.00149,2.00149,0,0,0-2.00183,2.001q0,.48651-.00781.9707a2.00229,2.00229,0,0,0,1.97247,2.03027h.03033a2.00154,2.00154,0,0,0,2.00085-1.97168q.00732-.513.00781-1.0293A2.00149,2.00149,0,0,0,125.99817,62.0191Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M89.64069,118.29248q-.437.20663-.87781.4079a2.0009,2.0009,0,1,0,1.66168,3.6405q.46774-.21323.93054-.43231a2.001,2.001,0,1,0-1.71442-3.61609Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M123.45288,81.78394a2.00356,2.00356,0,0,0-2.53455,1.26086q-.154.461-.31573.91992a2.00149,2.00149,0,1,0,3.775,1.33173c.1153-.32538.22675-.65173.33722-.97955A2.00071,2.00071,0,0,0,123.45288,81.78394Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M119.81866,91.10645a2.00252,2.00252,0,0,0-2.70264.84222q-.22586.428-.45746.852a2.00132,2.00132,0,1,0,3.511,1.92188q.24921-.45428.49066-.91449A2.00031,2.00031,0,0,0,119.81866,91.10645Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M125.51923,72.00311a2.00264,2.00264,0,0,0-2.29315,1.66q-.07617.47626-.16125.9502a2.00178,2.00178,0,0,0,3.9411.70441q.09091-.50995.173-1.02246A2.00134,2.00134,0,0,0,125.51923,72.00311Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M80.59918,121.71118c-.30988.08942-.62164.17633-.9325.26038a2.00118,2.00118,0,1,0,1.0459,3.86328q.4985-.13486.99506-.278a2.00113,2.00113,0,1,0-1.10846-3.8457Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M25.12457,109.82776a2.00126,2.00126,0,0,0-2.59027,3.05133c.26392.22375.52783.44458.79468.663a2.00148,2.00148,0,1,0,2.53943-3.09436Q25.49451,110.14072,25.12457,109.82776Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M33.82,115.96515q-.41931-.24408-.83276-.49292a2.00085,2.00085,0,1,0-2.07025,3.42456q.44275.26816.89142.52856a2.00122,2.00122,0,1,0,2.0116-3.46021Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M18.27258,103.00549a2.00145,2.00145,0,0,0-3.04773,2.59509c.22388.26282.4516.52417.6803.78308a2.00155,2.00155,0,0,0,2.99884-2.65173Q18.58438,103.3714,18.27258,103.00549Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M42.55457,120.13324q-.45447-.17368-.90607-.3537a2.00135,2.00135,0,1,0-1.48578,3.71674q.48093.192.96478.37616a2.00113,2.00113,0,1,0,1.42706-3.7392Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M51.84729,122.83282q-.4736-.09668-.9433-.20123a2.00119,2.00119,0,1,0-.87189,3.90625q.50436.11206,1.01367.21594a2.001,2.001,0,1,0,.80151-3.921Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M61.45081,123.99945q-.48532-.01978-.96771-.04694a2.00086,2.00086,0,1,0-.2287,3.99518q.51462.03,1.03217.05084c.02838.001.05573.00146.08307.00146a2.00111,2.00111,0,0,0,.08118-4.00055Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M71.11688,123.62671q-.478.05713-.96088.107a2.00079,2.00079,0,1,0,.41052,3.98047q.51471-.05273,1.02734-.11383a2.00108,2.00108,0,1,0-.477-3.97363Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M100,34H28A10.01146,10.01146,0,0,0,18,44V84A10.01146,10.01146,0,0,0,28,94h72a10.01146,10.01146,0,0,0,10-10V44A10.01146,10.01146,0,0,0,100,34Zm6,50a6.00656,6.00656,0,0,1-6,6H28a6.00656,6.00656,0,0,1-6-6V44a6.00656,6.00656,0,0,1,6-6h72a6.00656,6.00656,0,0,1,6,6Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "mediaServer-icon",
  d: "M75.49609,61.36188,58.03418,50.63513A4.68981,4.68981,0,0,0,51,54.69421V73.30914A4.69887,4.69887,0,0,0,55.6748,78a4.79637,4.79637,0,0,0,2.40625-.6601L75.47852,66.65271a3.06955,3.06955,0,0,0,.01758-5.29083ZM56.03418,73.90381A.689.689,0,0,1,55,73.30914V54.69421a.666.666,0,0,1,.34375-.5946.74624.74624,0,0,1,.36328-.103.557.557,0,0,1,.28027.07471l16.166,9.92993Z"
});

function SvgMediaServer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaServer);
export default __webpack_public_path__ + "static/media/mediaServer.762a8de6.svg";
export { ForwardRef as ReactComponent };